<template>
<div class="appcontainer page-wrap">
  <AppSettings />
</div>
</template>

<script>
import AppSettings from './components/AppSettings'

export default {
  name: 'appcontainer',
  components: {
    AppSettings
  }
}
</script>

<style lang="scss">
@import '@/scss/main.scss';
</style>
